import { useCallback } from "react";
import { HostRoutesHandle } from "../hostRoutes/HostRoutes";
import { DHCPPoolsHandle } from "../subnet/ipv4/dhcp/DHCPPools";
import { handleScrollToItem } from "../../../../../app_shared_functions";

const useCreateClickErrorHandler = ({
  error,
  dhcpPoolsError,
  hostRoutesError,
  showFormWarning,
  poolsRef,
  hostRoutesRef,
}: {
  error: any;
  dhcpPoolsError: string | null;
  hostRoutesError: string | null;
  showFormWarning: () => void;
  poolsRef: React.RefObject<DHCPPoolsHandle>;
  hostRoutesRef: React.RefObject<HostRoutesHandle>;
}) => {
  return useCallback(() => {
    showFormWarning();
    if (error) {
      handleScrollToItem(error.ref);
    } else if (dhcpPoolsError) {
      poolsRef?.current?.showError();
    } else if (hostRoutesError) {
      hostRoutesRef?.current?.showError();
    }
  }, [
    showFormWarning,
    dhcpPoolsError,
    hostRoutesError,
    error,
    hostRoutesRef,
    poolsRef,
  ]);
};

export default useCreateClickErrorHandler;
